import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Markdown`}</h1>
    <p>{`En su sintaxis soporta:`}</p>
    <h1>{`Titulos`}</h1>
    <h2>{`subtitulos`}</h2>
    <p>{`Parrafos como este con `}<em parentName="p">{`italicas`}</em>{`, `}<strong parentName="p">{`Negritas`}</strong>{` o `}<del parentName="p">{`tachados`}</del></p>
    <ul>
      <li parentName="ul">{`listas no ordenadas`}</li>
      <li parentName="ul">{`usando "*", "-" o bien "+"`}</li>
    </ul>
    <ol>
      <li parentName="ol">{`asi como listas enumeradas`}</li>
      <li parentName="ol">{`enumerando los elementos con el numero seguido por el carácter .`}<ol parentName="li">
          <li parentName="ol">{`Y ambos tipos de listas anidadas`}</li>
        </ol></li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      